import { isEmptyValue } from './definitions/shared';
import type { CompiledFieldNode, CompiledForm, ValidationIssue } from '../model/types';

export interface ArchiveReadiness {
  ready: boolean;
  missing: string[];
  issues: ValidationIssue[];
}

export const ANCHOR_MESSAGE = 'Campo âncora.';

function readiness(form: CompiledForm, required: (field: CompiledFieldNode) => boolean): ArchiveReadiness {
  const missing = form.fieldOrder.filter((fieldId) => {
    const field = form.fields[fieldId];
    return field.tags.anchor && !field.state.hiddenByRule && required(field) && isEmptyValue(field.value);
  });
  return {
    ready: missing.length === 0,
    missing,
    issues: missing.map((fieldId) => ({ fieldId, code: 'anchor', message: ANCHOR_MESSAGE })),
  };
}

// An anchor must be filled before the record is archived, whoever is looking. A field hidden by a
// rule is excluded because the form decided it does not apply; a field the viewer cannot edit still
// counts, since someone with the grant is expected to fill it.
export function archiveReadiness(form: CompiledForm): ArchiveReadiness {
  return readiness(form, () => true);
}

// Creating a record asks only for the anchors its creator can edit: an anchor granted to someone
// else stays empty until that person answers, and asking for it would block the creator for good.
export function creationReadiness(form: CompiledForm): ArchiveReadiness {
  return readiness(form, (field) => field.state.editable);
}
